import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import env from '@beam-australia/react-env';
import Button from 'shared/components/Button/Button';
import { RENEWAL } from 'constants/routeConstants';
import trackEvent from '../services/AnalyticsService';
import { setTescoPopupShown } from '../actions/sessionActions';

const TescoPanel = (props) => {
  const { jid, featureFlags, isTescoContinuous, updateTescoPopupShown } = props;
  const navigate = useNavigate();

  // The panel is mounted once per popup display, so this reports exactly one display event
  useEffect(() => {
    if (isTescoContinuous) {
      trackEvent('MyRAC_Tesco_Continuous_PopupDisplayed');
    } else {
      trackEvent('MyRAC_Tesco_PopupDisplayed');
    }
  }, []);

  const handleTescoRedirect = () => {
    if (isTescoContinuous) {
      trackEvent('MyRAC_Tesco_Continuous_Renew_Clubcard');
    } else {
      trackEvent('MyRAC_Tesco_Renew_Clubcard');
    }
    const url = `${featureFlags.tescoRenewalAks ? env('TESCO_AKS_LOGIN_REDIRECT_URL') : env('TESCO_LOGIN_REDIRECT_URL')}?JID=${jid}${env('TESCO_URL_QUERYSTRING')}`;
    window.open(url, '_blank');
  };

  const handleRenewDirect = () => {
    trackEvent('MyRAC_Tesco_Renew_Direct');
    // Store action in session so that popup is not displayed again until next user session
    updateTescoPopupShown(true);
    navigate(RENEWAL);
  };

  return (
    <div className="container">
      <div className="row text-center">
        {isTescoContinuous ? (
          <>
            <p>Your cover will renew automatically on your renewal date using the payment details you previously provided, unless you choose to pay using Clubcard vouchers.</p>
            <p>To renew with Clubcard vouchers, select the button below.</p>
          </>
        ) : (
          <p>You previously used your Tesco Clubcard vouchers to buy RAC Breakdown Cover. How would you like to renew today?</p>
        )}
        <div className={isTescoContinuous ? 'col-12 mb-3' : 'col-md-6 mb-3'}>
          <Button
            onClickHandler={handleTescoRedirect}
            buttonText="Use Tesco Vouchers"
            buttonStyles={{ backgroundColor: '#0152A1' }}
          />
        </div>
        {!isTescoContinuous && (
          <div className="col-md-6">
            <Button
              onClickHandler={handleRenewDirect}
              buttonText="Renew Directly"
              chevronWhite
            />
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  featureFlags: state.featureToggle,
});

const mapDispatchToProps = (dispatch) => ({
  updateTescoPopupShown: (tescoPopupShown) => {
    dispatch(setTescoPopupShown(tescoPopupShown));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TescoPanel);
